import { Link, useMatchRoute } from '@tanstack/react-router';

import { Collapsible } from '@/components/ui/collapsible';
import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar';
import { useConfig } from '@/hooks/use-config';
import { useOpen } from '@/hooks/use-open';

type NavItem = ReturnType<typeof useConfig>['mainNav'][number];

const NavMainItem = ({ item }: { item: NavItem }) => {
  const matchRoute = useMatchRoute();

  const { open, onOpenChange } = useOpen({
    defaultOpen: !!matchRoute({ to: item.href?.href, fuzzy: false }),
  });

  return (
    <Collapsible
      open={open}
      onOpenChange={onOpenChange}
      key={item.title}
      asChild>
      <SidebarMenuItem>
        <SidebarMenuButton
          asChild
          tooltip={item.title}
          onClick={() => {
            onOpenChange(true);
          }}>
          <Link to={item.href?.href}>
            <span>{item.title}</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </Collapsible>
  );
};

export const NavMain = () => {
  const { mainNav } = useConfig();

  return (
    <SidebarGroup>
      <SidebarMenu>
        {mainNav.map((item) => (
          <NavMainItem
            key={item.title}
            item={item}
          />
        ))}
      </SidebarMenu>
    </SidebarGroup>
  );
};
